import { formatValueOrCross } from "@/D2C/features/auth/utils/utils";
import { Checkbox } from "@/shared/components/Checkbox";
import InsurerLogoImage from "@/shared/components/InsurerLogoImage";
import { addQuoteToCompare } from "@/shared/redux/reducers/commonSlice";
import { closeModal } from "@/shared/redux/reducers/uiSlice";
import { usePosterReducers } from "@/shared/redux/store/useGetData";
import { formatAmountByConfig } from "@/shared/utils/amountFormat";
import { extractInsurerLogoFile } from "@/shared/utils/getInsurarLogo";
import { getQuoteAddOnItems } from "@/shared/utils/quoteAddOns";
import { handleQuoteBuyNowNavigation } from "@/shared/utils/quoteNavigation";
import { getNormalizedQuoteSections } from "@/shared/utils/quoteSections";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Button } from "../Button";
import CurrencySymbol from "./CurrencySymbol";
import {
  getQuoteItemPriceValue,
  isPositiveNumberLike,
  shouldShowQuoteItem,
  shouldUseAmountForDisplay,
} from "./quoteDisplay";
const QuoteDetail = ({ data, onBuyNow, isReadOnly = false }) => {
  const addons = getQuoteAddOnItems(data);
  const benificiaries = getNormalizedQuoteSections(data?.sections || []);
  const [activeTab, setActiveTab] = useState<"plan" | "addons">(
    addons.length > 0 ? "addons" : "plan"
  );
  const [isBuying, setIsBuying] = useState(false);
  const {
    commonSlice: { quoteList },
  } = usePosterReducers();
  const dispatch = useDispatch();
  const compareQuote = quoteList.filter((quote) => quote.isCompare);
  const matchCompare = compareQuote.some(
    (quote) => `${quote?.plan?.id}_${quote?.plan?.name}` === `${data?.plan?.id}_${data?.plan?.name}`
  );

  const navigate = useNavigate();
  console.log("data", data);

  const callBuyNow = () => {
    if (isReadOnly) {
      return;
    }

    setIsBuying(true);
    dispatch(closeModal());
    if (onBuyNow) {
      onBuyNow(data);
      return;
    }
    handleQuoteBuyNowNavigation(navigate, data);
  };

  // const renderCoverCard = (data, isFilter?: boolean) => {
  // let filterData;
  // filterData = data?.items?.filter(
  //   (section) =>
  //     section?.value !== "None" &&
  //     section?.value !== "false" &&
  //     section?.value !== null &&
  //     section?.value !== "Not Covered" &&
  //     section?.value !== false &&
  //     section?.value !== "-" &&
  //     section?.value !== undefined &&
  //     section?.value !== "0.0" && section?.value !== 0
  // );
  // if (isFilter) {
  //   filterData = data?.items?.filter(
  //     (section) =>
  //       section?.value !== "None" ||
  //       (section?.value === true && isPositiveNumberLike(section?.amount)),
  //   );
  // }
  const renderCoverCard = (data) => {
    const filterData = (data?.items || []).filter(shouldShowQuoteItem);

    return (
      <>
        {filterData?.length > 0 && data.title && (
          <div className="flex items-center gap-2">
            <span className="h-2 w-2 rounded-full bg-theme-primary" />
            <span className="text-sm font-semibold text-theme-text uppercase tracking-wide">
              {data.title}
            </span>
          </div>
        )}
        <div className="mt-2 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4 text-sm">
          {filterData?.map((item, idx) => (
            <div
              key={idx}
              className="rounded-xl border border-theme-border/70 bg-theme-surface p-4 shadow-sm space-y-2"
            >
              <div className="flex items-center justify-between">
                <p className="text-sm font-semibold text-theme-text m-0">{item.label}</p>
                {item?.is_checked && (
                  <div className="flex justify-center items-center mb-1 text-xs">
                    <p className="bg-theme-success-bright-soft rounded-full w-fit px-2 py-1">
                      ✓ Selected
                    </p>
                  </div>
                )}
              </div>
              {isPositiveNumberLike(getQuoteItemPriceValue(item)) &&
                !shouldUseAmountForDisplay(item) && (
                  <>
                    <p className="p-0 m-0 text-theme-text-soft">Premium amount</p>
                    <div className="flex items-center  text-lg font-semibold text-theme-success-text-strong ">
                      <CurrencySymbol
                        currency={item.currency}
                        value={getQuoteItemPriceValue(item)}
                      />
                      <p>
                        {formatValueOrCross(getQuoteItemPriceValue(item)) === "❌"
                          ? 0
                          : formatValueOrCross(getQuoteItemPriceValue(item))}
                      </p>
                    </div>
                  </>
                )}
              {shouldUseAmountForDisplay(item) ? (
                <>
                  <p className="p-0 m-0 text-theme-text-soft">Included amount</p>
                  <div className="flex items-center  text-lg font-semibold text-theme-success-text-strong">
                    <CurrencySymbol currency={item.currency} value={item.amount} />
                    <p>
                      {formatValueOrCross(item.amount) === "❌"
                        ? 0
                        : formatValueOrCross(item.amount)}
                    </p>
                  </div>
                </>
              ) : item?.value === true ? (
                <>
                  <p className="p-0 m-0 text-theme-text-soft">Status</p>
                  <div className="flex items-center text-lg font-semibold text-theme-success-text-strong">
                    <p>Included</p>
                  </div>
                </>
              ) : (
                formatValueOrCross(item.value) !== "❌" && (
                  <>
                    <p className="p-0 m-0 text-theme-text-soft">Insured amount</p>
                    <div className="flex items-center  text-lg font-semibold text-theme-success-text-strong">
                      <CurrencySymbol currency={item.currency} value={item.value} />
                      <p>
                        {formatValueOrCross(item.value) === "❌"
                          ? 0
                          : formatValueOrCross(item.value)}
                      </p>
                    </div>
                  </>
                )
              )}
              <p>{item?.description}</p>
            </div>
          ))}
        </div>
      </>
    );
  };

  return (
    <div className="w-full bg-theme-surface rounded-2xl pb-10">
      {/* <CompareBar /> */}
      {/* Header */}
      <div className="flex items-start justify-between pb-4">
        <div className="flex items-center gap-4">
          <div className="flex h-20 w-44 items-center justify-center">
            <InsurerLogoImage
              insurerName={data?.insurer?.name}
              insurerLogoFile={extractInsurerLogoFile(data?.insurer)}
              alt="insurer"
              className="max-h-16 max-w-40 object-contain"
            />
          </div>

          <div>
            <h2 className="text-lg font-semibold text-theme-text">
              {data?.insurer?.name} ({data?.plan?.name})
            </h2>

            {/* <div className="mt-2 flex gap-6 text-sm text-theme-text-muted">
              <p>
                Car Value (AED) <br />
                <span className="font-semibold text-theme-text">146,000</span>
              </p>
              <p>
                Excess Amount (AED) <br />
                <span className="font-semibold text-theme-text">500</span>
              </p>
            </div> */}
          </div>
        </div>

        <div className="flex items-center gap-3">
          <p className="text-lg font-semibold text-theme-text">
            <div className="flex items-center">
              <CurrencySymbol
                currency={data?.plan?.price?.currency}
                value={data?.plan?.price?.amount_with_vat}
              />
              <p className="text-lg">
                {" "}
                {formatAmountByConfig(data?.plan?.price?.amount_with_vat)}{" "}
              </p>
              {/* <p className="text-sm font-normal ml-1 mt-1"> +VAT</p> */}
            </div>
          </p>
          <Button
            onClick={callBuyNow}
            isLoading={isBuying}
            disabled={isReadOnly}
            loadingText="Processing..."
          >
            Buy Now
          </Button>
        </div>
      </div>

      {/* Tabs */}
      <div className="flex items-center justify-between ">
        <div className="flex gap-6">
          <button
            onClick={() => setActiveTab("plan")}
            className={`pb-2 text-sm font-medium transition cursor-pointer
              ${
                activeTab === "plan"
                  ? "text-theme-success-text-strong border-b-2 border-theme-success-text-strong"
                  : "text-theme-text-soft hover:text-theme-text-muted"
              }`}
          >
            Benefits
          </button>

          {addons?.length > 0 && (
            <button
              onClick={() => setActiveTab("addons")}
              className={`pb-2 text-sm font-medium transition cursor-pointer
              ${
                activeTab === "addons"
                  ? "text-theme-success-text-strong border-b-2 border-theme-success-text-strong"
                  : "text-theme-text-soft hover:text-theme-text-muted"
              }`}
            >
              Add-ons
            </button>
          )}
        </div>

        <Checkbox
          color="green"
          label="Add To Compare"
          labelClassName="text-theme-text-muted"
          checked={matchCompare}
          disabled={isReadOnly}
          onChange={() => {
            if (isReadOnly) {
              return;
            }
            dispatch(addQuoteToCompare(data));
          }}
        />
      </div>

      {/* Plan Details */}
      {activeTab === "plan" && (
        <div className="mt-6 ">
          {benificiaries?.map((benifit, index) => (
            <div key={index} className="  p-4 ">
              {renderCoverCard(benifit)}
            </div>
          ))}
        </div>
      )}

      {/* Add-ons */}
      {activeTab === "addons" && renderCoverCard({ items: addons })}
    </div>
  );
};

export default QuoteDetail;
